'use client';

import { PositionDirection } from '@drift-labs/sdk';
import { ENUM_UTILS } from '@drift/common';
import { AccountOrder } from '../types';

interface ActionCellProps {
	order: AccountOrder;
}

export function ActionCell({ order }: ActionCellProps) {
	const isLong = ENUM_UTILS.match(order.direction, PositionDirection.LONG);

	return (
		<span
			className={
				isLong
					? 'text-text-positive-green-button'
					: 'text-text-negative-red-button'
			}
		>
			{order.reduceOnly
				? `Close ${isLong ? 'Short' : 'Long'}`
				: isLong
					? 'Long'
					: 'Short'}
		</span>
	);
}
